import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import AddToHomeScreen from './components/AddToHomeScreen';
import { useTheme } from './context/ThemeContext';

const App = () => {
  const { theme } = useTheme();

  return (
    <>
      <AddToHomeScreen />
      <Header />
      <main className='app-main'>
        <Container>
          <Outlet />
        </Container>
      </main>
      <Footer />
      <ToastContainer
        theme={theme === 'dark' ? 'dark' : 'colored'}
        position='top-right'
        autoClose={3500}
      />
    </>
  );
};

export default App;
